module.exports = __webpack_public_path__ + "media/images/lms/blackboard-23236b7d62172fdbdca1dd26b1bf95df.png";